import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsCZFeatureConfig: DeepPartial<ProductSettings> = {
    showAccountInfo: true,
};
